// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Transportistas y tránsito promedio, en el dashboard del cliente (20-oct-2026). Ver CarriersCard.tsx. */

.CarriersCard_card__JJsuS {
  position: relative;
  overflow: hidden;
}
.CarriersCard_card__JJsuS::before {
  content: '';
  position: absolute;
  inset: 0;
  background: radial-gradient(
    140% 80% at 100% 0%,
    color-mix(in srgb, #2f9fd0 11%, transparent) 0%,
    transparent 55%
  );
  pointer-events: none;
}
.CarriersCard_card__JJsuS > * {
  position: relative;
}

.CarriersCard_summary__miqUU {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: -4px 0 16px;
}
.CarriersCard_big__zUruh {
  font-size: 34px;
  font-weight: 700;
  line-height: 1;
  letter-spacing: -0.02em;
  color: var(--dylo-ink);
  font-variant-numeric: tabular-nums;
}
.CarriersCard_bigLabel__-KMAa {
  display: flex;
  flex-direction: column;
  gap: 2px;
  font-size: 13px;
  font-weight: 500;
  color: var(--dylo-ink);
}
.CarriersCard_hint__4QL-u {
  font-size: 11.5px;
  font-weight: 400;
  color: var(--dylo-muted);
}

.CarriersCard_list__bcham {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.CarriersCard_item__PM1Qj {
  display: grid;
  grid-template-columns: 32px minmax(0, 1fr);
  align-items: center;
  gap: 10px;
}

.CarriersCard_avatar__TyKU9 {
  width: 32px;
  height: 32px;
  display: grid;
  place-items: center;
  border-radius: 10px;
  font-size: 11.5px;
  font-weight: 700;
  color: var(--dylo-ink);
  background: color-mix(in srgb, var(--tone) 22%, transparent);
  box-shadow: inset 0 0 0 1px color-mix(in srgb, var(--tone) 45%, transparent);
}

.CarriersCard_body__2amKz {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.CarriersCard_line__ukRIJ {
  display: flex;
  align-items: baseline;
  gap: 8px;
}
.CarriersCard_name__-RqWT {
  flex: 1 1;
  min-width: 0;
  font-size: 13px;
  font-weight: 600;
  color: var(--dylo-ink);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.CarriersCard_loads__XmGGA {
  font-size: 12px;
  font-weight: 700;
  color: var(--dylo-ink);
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
}

.CarriersCard_track__zdDwW {
  height: 5px;
  border-radius: 999px;
  background: color-mix(in srgb, var(--dylo-ink) 8%, transparent);
  overflow: hidden;
}
.CarriersCard_bar__J6-Fe {
  display: block;
  height: 100%;
  min-width: 4px;
  border-radius: inherit;
  background: var(--tone);
  transform-origin: left center;
  animation: CarriersCard_cc-grow__Pc0-R 0.7s cubic-bezier(0.2, 0.7, 0.2, 1) both;
}

.CarriersCard_avg__oQSox {
  font-size: 11.5px;
  color: var(--dylo-muted);
}

.CarriersCard_empty__nOegB {
  margin: 4px 0;
  font-size: 13px;
  color: var(--dylo-muted);
}

@keyframes CarriersCard_cc-grow__Pc0-R {
  from {
    transform: scaleX(0);
  }
}

@media (prefers-reduced-motion: reduce) {
  .CarriersCard_bar__J6-Fe {
    animation: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/v2/pages/Dashboard/components/CarriersCard.module.css"],"names":[],"mappings":"AAAA,yGAAyG;;AAEzG;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR;;;;GAIC;EACD,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,sBAAsB;EACtB,kCAAkC;AACpC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,4DAA4D;EAC5D,4EAA4E;AAC9E;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;AACV;AACA;EACE,SAAO;EACP,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,+DAA+D;EAC/D,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,YAAY;EACZ,cAAc;EACd,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;EAC7B,+EAA2D;AAC7D;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":["/* Transportistas y tránsito promedio, en el dashboard del cliente (20-oct-2026). Ver CarriersCard.tsx. */\n\n.card {\n  position: relative;\n  overflow: hidden;\n}\n.card::before {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background: radial-gradient(\n    140% 80% at 100% 0%,\n    color-mix(in srgb, #2f9fd0 11%, transparent) 0%,\n    transparent 55%\n  );\n  pointer-events: none;\n}\n.card > * {\n  position: relative;\n}\n\n.summary {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin: -4px 0 16px;\n}\n.big {\n  font-size: 34px;\n  font-weight: 700;\n  line-height: 1;\n  letter-spacing: -0.02em;\n  color: var(--dylo-ink);\n  font-variant-numeric: tabular-nums;\n}\n.bigLabel {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--dylo-ink);\n}\n.hint {\n  font-size: 11.5px;\n  font-weight: 400;\n  color: var(--dylo-muted);\n}\n\n.list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.item {\n  display: grid;\n  grid-template-columns: 32px minmax(0, 1fr);\n  align-items: center;\n  gap: 10px;\n}\n\n.avatar {\n  width: 32px;\n  height: 32px;\n  display: grid;\n  place-items: center;\n  border-radius: 10px;\n  font-size: 11.5px;\n  font-weight: 700;\n  color: var(--dylo-ink);\n  background: color-mix(in srgb, var(--tone) 22%, transparent);\n  box-shadow: inset 0 0 0 1px color-mix(in srgb, var(--tone) 45%, transparent);\n}\n\n.body {\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n\n.line {\n  display: flex;\n  align-items: baseline;\n  gap: 8px;\n}\n.name {\n  flex: 1;\n  min-width: 0;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--dylo-ink);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.loads {\n  font-size: 12px;\n  font-weight: 700;\n  color: var(--dylo-ink);\n  white-space: nowrap;\n  font-variant-numeric: tabular-nums;\n}\n\n.track {\n  height: 5px;\n  border-radius: 999px;\n  background: color-mix(in srgb, var(--dylo-ink) 8%, transparent);\n  overflow: hidden;\n}\n.bar {\n  display: block;\n  height: 100%;\n  min-width: 4px;\n  border-radius: inherit;\n  background: var(--tone);\n  transform-origin: left center;\n  animation: cc-grow 0.7s cubic-bezier(0.2, 0.7, 0.2, 1) both;\n}\n\n.avg {\n  font-size: 11.5px;\n  color: var(--dylo-muted);\n}\n\n.empty {\n  margin: 4px 0;\n  font-size: 13px;\n  color: var(--dylo-muted);\n}\n\n@keyframes cc-grow {\n  from {\n    transform: scaleX(0);\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .bar {\n    animation: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `CarriersCard_card__JJsuS`,
	"summary": `CarriersCard_summary__miqUU`,
	"big": `CarriersCard_big__zUruh`,
	"bigLabel": `CarriersCard_bigLabel__-KMAa`,
	"hint": `CarriersCard_hint__4QL-u`,
	"list": `CarriersCard_list__bcham`,
	"item": `CarriersCard_item__PM1Qj`,
	"avatar": `CarriersCard_avatar__TyKU9`,
	"body": `CarriersCard_body__2amKz`,
	"line": `CarriersCard_line__ukRIJ`,
	"name": `CarriersCard_name__-RqWT`,
	"loads": `CarriersCard_loads__XmGGA`,
	"track": `CarriersCard_track__zdDwW`,
	"bar": `CarriersCard_bar__J6-Fe`,
	"cc-grow": `CarriersCard_cc-grow__Pc0-R`,
	"avg": `CarriersCard_avg__oQSox`,
	"empty": `CarriersCard_empty__nOegB`
};
export default ___CSS_LOADER_EXPORT___;
